import { View } from "binder"
import { IExecutablePart } from "../../executablePart/executablePart";
import { PreAfterAdderViewModel } from "./preAfterAdder-viewModel"

export class PreAfterAdderView extends View<PreAfterAdderViewModel>{
    GetViewUniqueId(): string {
        return "V-AEEF8BD4-8CB7-4818-93EE-72A8F3246548"
    }
    loadHtml(): string {
        let element = require('./preAfterAdder.html').default;
        let style = require('./preAfterAdder.less');
        return element;
    }
    constructor() {
       super();
    }

    public set shallShow(v: boolean) { this._shallShow = v; } public get shallShow(): boolean { return this._shallShow;} private _shallShow: boolean;
    public set part(v: IExecutablePart) { this._part = v; } public get part(): IExecutablePart { return this._part;} private _part: IExecutablePart;
    
    addBefore(){
        this.dataContext.addBefore();
    }
    addAfter(){
        this.dataContext.addAfter();
    }
    remove(){
        this.dataContext.remove();
    }
}
